import React, { useMemo } from "react";
import styled, { css } from "styled-components";
import { hexToRGBA } from "../../../../utils/theme";

const StyledProgressSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 2rem;
  padding: 1rem 0;
  background-color: #0097e6;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
  .progress-bar-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    gap: 32px;
    .progress-bar-title {
      font-family: 'RobotoBold';
      white-space: nowrap;
      font-size: 16px;
      line-height: calc(1.42857rem * (14 / 16));
      color: #ffffff;
    }

    .progress-bar-desktop-steps {
      display: flex;
      font-family: 'RobotoBold';
      font-size: 16px;
      line-height: calc(1.42857rem * (14 / 16));
      width: 100%;
    }

    .progress-bar-mobile-steps {
      font-family: 'RobotoRegular';
      color: #ffffff;
      font-size: 16px;
      line-height: calc(1.42857rem * (14 / 16));
      opacity: 0.6;
    }
  }

  @media ${({ theme }) => theme.devices.laptopS} {
    .progress-bar-container {
      width: 720px;
    } 
  }

  @media ${({ theme }) => theme.devices.tablet} {
    .progress-bar-container {
      width: 100%;
      justify-content: space-between;
    } 
  }
  @media (min-width: 768px) {
    width: 750px;
  }
  @media (min-width: 992px) {
    width: 970px;
  }
  @media (min-width: 1024px) {
    width: 990px;
  }
  @media (min-width: 1200px) {
    width: 1170px;
  }
  @media (min-width: 1280px) {
    padding-left: 40px;
    padding-right: 40px;
    width: 1170px;
  }
  @media (min-width: 1600px) {
    padding-left: 115px;
    padding-right: 115px;
    width: 1440px;
  }
`;

const StyledStep = styled.div`
  margin-left: 40px;
  color: #FFFFFF;
  font-family: RobotoRegular;

  &:first-child {
    margin-left: 0;
  }

  ${({ active }) => active && css`
    font-family: RobotoBold;
    color: #FFFFFF;
  `}
`;

function ProgressSection({ mobile, currentStep, steps = [], currentSubStep, maxSubStep }) {
  const activeTitle = useMemo(() => steps.find(({ step }) => step === currentStep)?.title, [steps, currentStep]);

  return (
    <StyledProgressSection>
      <div className="progress-bar-container">
        <div className="progress-bar-title">
          {!mobile && (<span>Submission Progress</span>)}
          {mobile && (<span>{activeTitle}</span>)}
        </div>
        {!mobile && (
          <div className="progress-bar-desktop-steps">
            {steps.map(({ step, title }) => (
              <StyledStep key={step} active={step === currentStep}>
                <span>{title}</span>
              </StyledStep>
            ))}
          </div>
        )}
        {mobile && currentSubStep && (
          <div className="progress-bar-mobile-steps">
            <span>{`Step ${currentSubStep} of ${maxSubStep}`}</span>
          </div>
        )}
      </div>
    </StyledProgressSection>
  );
}

export default ProgressSection;
